<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button v-if="backRole('CT_1')" type="primary" @click="startCreate()" size="mini">新建合同</el-button>
      </div>
      <el-row>
        <el-col class="item-select" :span="5">
          <label>合同状态：</label>
          <el-select size="mini" v-model="filterStatus" placeholder="请选择">
            <el-option v-for="item in statusArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="filterKey" size="mini" placeholder="你可以搜索合同名称/创建人"></el-input>
        </el-col>
      </el-row>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="合同名称">
        <template slot-scope="scope">
          <span v-html="getTypeName(scope.row.type)"></span>
          <router-link :to="'/Contract/Detail/'+scope.row.id" class="link" target="_blank">{{ scope.row.name }}</router-link>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" width="100px">
        <template slot-scope="scope">
          {{ contractTypeName[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80px">
      </el-table-column>
      <el-table-column label="合同负责人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.leader'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="120px">
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Contract/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
          <el-button v-if="scope.row.status=='新建完成' && scope.row.leader.id==userData.id" type="danger" plain size="mini"
            @click="contractDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        contractTypeName: ['独立合同', '工程施工合同', '子项目合同'],


        // projectListStatus: false,
        // projectDepId: "",
        // projectKey: "",
        // projectFilterList: [],
        // projectList: [],
        // projects: [],

        filterKey: "",
        filterStatus: "全部",
        statusArr: ["全部", "新建完成", "招标中", "招标完成", "签订中", "签订完成", "实施中", "验收完成"],

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // typeName
        typeName: ['合同', '工程合同', '子项目'],
      }
    },
    mounted() {
      if (!this.userData) {
        return false
      }

      this.organizationListData.push({
        id: 0,
        name: "集团所有公司",
        depId: 0
      })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.projectDepId = this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7") {
        this.noSelectOrganization = false
        this.depId = 0
      }

      // 获取列表
      this.getLists()
    },
    methods: {

      getTypeName(type) {
        return '<span class="approval-type at' + type + '">' + this.typeName[type] + '</span>'
      },
      contractDelete(row) {
        this.$confirm('此操作将永久删除该合同, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          ajax.post('/contract/del', {
            contractId: row.id
          }, (res) => {
            this.$message.error("删除合同成功")
            // 重新获取列表
            this.getLists()
          })

          // ajax.post('/contract/del/' + row.id, "", (res) => {
          //   this.$message.error("删除合同成功")
          //   // 重新获取列表
          //   this.getLists()
          // })
        }).catch(() => {});
      },
      // EditMeeting(row) {
      //   this.$router.push('/Meeting/Edit/' + row.id)
      // },
      startCreate() {
        this.$router.push("/Contract/Create")
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterStatus != "全部" || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]

            // 筛选状态
            let _filterStatus = true
            if (this.filterStatus != "全部") {
              if (this.filterStatus != _new.status) {
                _filterStatus = false
              }
            }
            if (_filterStatus) {
              if (_new.name.indexOf(this.filterKey) != -1 || _new.creator.name.toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_new)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/user/contract/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'depId'() {
        this.getLists()
      },
      'filterStatus'() {
        this.getFilterData()
      },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/user/contractlist.vue